import { SelectedItemsPanel } from 'pages/custom_tests_v1/components/assign_wizard/components/selected_items_panel/SelectedItemsPanel';
import type { AssignableItem } from 'pages/custom_tests_v1/components/assign_wizard/AssignWizard';
import type { GMetrixTableColumnProps } from 'components/GMetrixTable/components';
import { GMetrixTable } from 'components';
import { Button } from 'react-bootstrap';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';
import { formatDay } from 'utils';

type ClassroomPickerViewProps = {
    assignedIds?: number[];
    classrooms: AssignableItem[];
    onChange: (selected: AssignableItem[]) => void;
    selected: AssignableItem[];
};

export const ClassroomPickerView = (props: ClassroomPickerViewProps) => {

    const { assignedIds = [], classrooms, onChange, selected } = props;

    const intl = useIntl();
    const { formatMessage } = intl;

    const [state, setState] = useSuperState({
        searchTerm: ''
    });

    const setSearchTerm = (searchTerm: string) => setState({ searchTerm });

    const handleSelect = (classroom: AssignableItem) => {

        if (selected.some(({ Id }) => Id === classroom.Id)) return;

        onChange([...selected, classroom]);

    };

    const handleRemove = (classroom: AssignableItem) => onChange(selected.filter(({ Id }) => Id !== classroom.Id));

    const displayList = (state.searchTerm
        ? classrooms.filter(c => c.Name.toLowerCase().includes(state.searchTerm.toLowerCase()) || c.Description.toLowerCase().includes(state.searchTerm.toLowerCase()))
        : classrooms
    ).map(item => ({
        ...item,
        isSelected: selected.some(({ Id }) => Id === item.Id)
    }));

    const columns: GMetrixTableColumnProps<AssignableItem & { isSelected: boolean }>[] = [
        {
            field: 'Name',
            title: formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' })
        },
        {
            field: 'Description',
            title: formatMessage({ id: 'description.6317db73', defaultMessage: 'Description' })
        },
        {
            cell: ({ dataItem }) => (
                <td>
                    {formatDay(dataItem.CreatedDate, intl)}
                </td>
            ),
            field: 'CreatedDate',
            title: formatMessage({ id: 'created.8d9f8791', defaultMessage: 'Created' })
        },
        {
            cell: ({ dataItem }) => (
                <td>
                    {dataItem.isSelected ?
                        (
                            <Button disabled size={'sm'} variant={'outline-success'}>
                                <i className="fa-solid fa-check" />
                            </Button>
                        )
                        :
                        (
                            <Button
                                disabled={selected.some(({ Id }) => Id === dataItem.Id)}
                                onClick={() => handleSelect(dataItem)}
                                size={'sm'}
                            >
                                <i className="fa-solid fa-plus" />
                            </Button>
                        )
                    }

                </td>
            ),
            title: '',
            width: '1%'
        }
    ];

    return (
        <div className={'d-flex flex-column gap-3'}>

            <GMetrixTable
                columnData={columns}
                defaultItemsPerPage={10}
                noDataMessage={formatMessage({ id: 'no_classrooms_found.60f375dc', defaultMessage: 'No classrooms found.' })}
                rowData={displayList}
                searchTerm={state.searchTerm}
                setSearchTerm={setSearchTerm}
            />

            <SelectedItemsPanel assignedIds={assignedIds} items={selected} onRemove={handleRemove} />

        </div>
    );

};

ClassroomPickerView.displayName = 'ClassroomPickerView';